export default {
  state: {
    microRoutes: {
      microLsp: [],
      microLsrm: [],
      microNtp: [],
      microOms: [],
      microTms: [],
      microDataReport: [],
    },
    microLang: {
      microLsp: {},
      microLsrm: {},
      microNtp: {},
      microOms: {},
      microTms: {},
      microDataReport: {},
    },
  },
  getters: {},
  mutations: {
    updateMicroRoutes(
      state: { microRoutes: { [x: string]: any }; microLang: { [x: string]: any } },
      data: { microName: string | number; routes: any; lang: any },
    ) {
      if (state.microRoutes[data.microName] && data.routes) {
        state.microRoutes[data.microName] = data.routes;
      }
      if (state.microLang[data.microName] && data.lang) {
        state.microLang[data.microName] = data.lang;
      }
    },
  },
  actions: {},
};
